import { t } from 'i18next';
import { Text, TextButton } from '../../../components';
import { usePageStrings } from '../../../hooks';
import styles from './AssumedIdentityBanner.module.scss';
import { RootState, useAppSelector } from '../../../../store';

interface IComponentProperties {
    revertIdentityClicked?: Function
}

export function AssumedIdentityBanner (props: IComponentProperties) {
    const authorization = useAppSelector((state: RootState) => state.authorization);
       
    const pageStrings = usePageStrings();

    const message = t(pageStrings.layout.text_identityAssumed)
        .replace('{0}', authorization.userDisplayName)
        .replace('{1}', authorization.userIdentifier);
    return (
        <div className={styles['AssumedIdentityBanner']} role='status'>
            <div className={styles['AssumedIdentityBanner-message']}>
                <Text fontStyle={'body-medium'} value={message}></Text>
            </div>
            <div className={styles['AssumedIdentityBanner-link']}>
                <TextButton type='button' value={pageStrings.layout.button_revertIdentity_label} onClick={props.revertIdentityClicked}></TextButton>
            </div>
        </div>
    )
}